import { render, staticRenderFns } from "./arquivosliberados.vue?vue&type=template&id=0cbde90e&"
import script from "./arquivosliberados.vue?vue&type=script&lang=js&"
export * from "./arquivosliberados.vue?vue&type=script&lang=js&"
import style0 from "./arquivosliberados.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports